module.exports = "/_next/static/images/WantToRetainCustomers-sm-42ab85ff0e25fa424137eec35129b720.webp";